import { Footer } from 'antd/lib/layout/layout';
import React from 'react';
import moment from 'moment';

const FooterContent = () => (
    <Footer style={{ textAlign: 'center' }}>
        Buzón Digital 2.0.0 ©
        {' '}
        {moment().year()}
        . Desarrollado por la
        {' '}
        <a target="_blank" href="https://ease.gob.mx/" rel="noreferrer">ASED</a>
        .
    </Footer>
);

export default FooterContent;
